module.exports = __webpack_public_path__ + "static/media/Apple iPad Pro 11\" Silver - Portrait.7b8d034c.png";